/* globals alert, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
/* jscs:disable disallowDanglingUnderscores */
'use strict';

const async = require('async'),
    Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    // jQuery = require('jquery'),
    _ = require('lodash'),
    //
    Program = require('../models/program'),
    Contacts = require('../collections/contacts'),
    //
    AddressAutocomplete = require('../utilities/addressAutocomplete'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    user = require('../models/user'),
    url = configuration.mockdata.programs ? '/mockdata/programs.json'  : configuration.apiUrlBase + 'programs',
    EOL = null;

module.exports = Backbone.Collection.extend({
    channels: {
        console: BackboneRadio.channel('console')
    },
    model: Program,
    filters: undefined,
    mergedFilters: {},
    //
    applyFilters: _.debounce(function (serializedFilters, source, always) {
        // @acavan! - consider making programSidebarFilters the canonical source for filters and have programHeaderFilter
        //      notify sidebar of changes rather than talking to collection directly
        const processedFilters = source !== 'crushedFilters' ? formProcessor(serializedFilters, 'filters') : serializedFilters;
        this.applyProcessedFilters(processedFilters, source, always);
    }, configuration.debounceInterval, {trailing: true}),
    applyProcessedFilters: function (processedFilters, source, always) {
        // console.log('@programs.applyProcessedFilters', processedFilters, source);
        let sources = [{}];
        // console.log(source, processedFilters);
        // delete processedFilters.keywords;
        if (processedFilters.latitude === -1 && processedFilters.longitude === -1) {
            delete processedFilters.location;
            delete processedFilters.latitude;
            delete processedFilters.longitude;
            delete processedFilters.miles;
        }
        this.filters[source] = processedFilters;
        _.each(_.keys(this.filters), _.bind(function (filter) {
            sources.push(this.filters[filter]);
        }, this));
        this.mergedFilters = _.merge.apply(_, sources);
        if (this.mergedFiltersPrior !== JSON.stringify(this.mergedFilters) || always) {
            this.mergedFiltersPrior = JSON.stringify(this.mergedFilters);
            if (!processedFilters.favorites) {
                this.logFilters('applyFilters_' + this._listenId);
                this.fetch({
                    contentType: 'application/json',
                    data: JSON.stringify(this.mergedFilters),
                    headers: user.authorizationHeader('programs'),
                    method: configuration.mockdata.programs || this.via === 'reports' ? 'GET' : 'POST',
                    reset: true,
                    url: !this.mergedFilters.programIds ? url : configuration.apiUrlBase + 'listedPrograms'
                });
            } else {
                this.fetch({
                    contentType: 'application/json',
                    headers: user.authorizationHeader('programs'),
                    method: 'GET',
                    reset: true,
                    url: configuration.apiUrlBase + 'favorites'
                });
            }
        }
    },
    create: function (programSerializedValues, primaryContactSerializedValues, callback) {
        const programProcessedValues = formProcessor(programSerializedValues, 'programs');
        let program,
            contacts;
        async.waterfall([
            // resolve the address
            _.bind(function (callback) {
                if (programProcessedValues.resolveLocation) {
                    this.resolveLocation(programProcessedValues.zip, _.bind(function (error, location) {
                        if (error || location.error) {
                            callback(error || location.error);
                        } else {
                            callback(null, location);
                        }
                    }, this));
                } else {
                    callback(null, {});
                }
            }, this),
            _.bind(function (location, callback) {
                const values = _.extend({organizationId: this.organizationId}, programProcessedValues, location);
                if (!values.countyId) {
                    delete values.countyId;
                }
                program = new Program(values);
                program.save(null, {
                    success: _.bind(function (model, response, options) {
                        model.set({programs: 0, units: 0, vacancies: 0}, {silent: true});
                        callback(null, model);
                    }, this),
                    error: function (model, xhr, options) {
                        callback('Unable to create program' + (xhr.responseJSON ? '\n(' + xhr.responseJSON.message + ')' : ''));
                    }
                });
            }, this),
            _.bind(function (program, callback) {
                contacts = new Contacts([], {type: 'program', id: program.id});
                contacts.createContact(primaryContactSerializedValues, function (error) {
                    callback(error, program);
                });
            }, this)
        ], _.bind(function (error, program) {
            if (!error) {
                this.add(program);
            } else {
                if (callback) {
                    callback(error);
                } else {
                    alert(error);
                }
            }
        }, this));
    },
    currentFilters: function () {
        return this.mergedFilters;
    },
    initialize: function (items, options) {
        this.filters = {};
        this.via = options.via;
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.logFilters('onChangeRoles_' + this._listenId);
            this.fetch({
                contentType: 'application/json',
                data: JSON.stringify(this.mergedFilters),
                headers: user.authorizationHeader('programs'),
                method: configuration.mockdata.programs ? 'GET' : 'POST',
                reset: true,
                url: url // configuration.apiUrlBase + 'programs'
            });
        }, this));
        this.resolveLocation = new AddressAutocomplete().resolveLocation;
    },
    logFilters: function (via) {
        this.channels.console.trigger('log', 'programs.filters: ' + JSON.stringify(this.mergedFilters) + ' (' + via + ')');
    },
    organization: function (organizationId) {
        this.organizationId = organizationId;
        this.logFilters('organization_' + this._listenId);
        this.fetch({
            headers: user.authorizationHeader('programs'),
            method: 'GET',
            reset: true,
            url: url + (configuration.mockdata.programs ?  '' : '/' + organizationId)    // configuration.apiUrlBase + 'programs/' + organizationId
        });
    },
    reload: function () {
        // console.log('@programs.reload', this.via);
        this.fetch({
            headers: user.authorizationHeader('programs'),
            method: 'GET',
            reset: true,
            // success: _.bind(function () {this.sortAttribute(this.attributeOrder);}, this),
            url: url
        });
    }
});
